const classes = {
  loaded: 'is-loaded',
};

const selectors = {
  img: 'img:not(.is-loaded)',
};

// Catch images loaded events and add class "is-loaded" to them image and their container
function loadedImagesEventHook() {
  document.addEventListener(
    'load',
    (e) => {
      if (e.target.tagName == 'IMG' && !e.target.classList.contains(classes.loaded)) {
        e.target.classList.add(classes.loaded);
        e.target.parentNode.classList.add(classes.loaded);
      }
    },
    true
  );
}

/*
  Add class "is-loaded" to the loaded images and their container
*/
function addLoadedClassFromLoadedImages(container) {
  container.querySelectorAll(selectors.img).forEach((img) => {
    if (img.complete) {
      img.classList.add(classes.loaded);
      img.parentNode.classList.add(classes.loaded);
    }
  });
}

export {loadedImagesEventHook, addLoadedClassFromLoadedImages};
